import { Navigate } from "react-router-dom";
import { currentUser } from "../lib/api";
export function RequireRole({ roles, children }) {
    const user = currentUser();
    if (!user || !roles.includes(user.role)) {
        return <Navigate to="/legal-cases" replace/>;
    }
    return <>{children}</>;
}
